exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sr-qiankun-view .searchPage[data-v-5d3d175a]{display:flex;justify-content:space-between}.sr-qiankun-view .searchRightBtn[data-v-5d3d175a]{display:inline-block}.sr-qiankun-view .searchRightBtn button[data-v-5d3d175a]{width:76px;height:32px;border-radius:16px;padding:5px 24px}.sr-qiankun-view .tabsLabel[data-v-5d3d175a]{font-size:16px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:#333;line-height:24px}.sr-qiankun-view .tabsLabel i[data-v-5d3d175a]{margin-right:4px}.sr-qiankun-view ::v-deep .el-tabs__header[data-v-5d3d175a]{margin-bottom:16px!important}.sr-qiankun-view .tabsDataTitle[data-v-5d3d175a]{margin-top:8px;font-family:PingFangSC-Medium,PingFang SC;font-weight:600;color:#333;line-height:22px;margin-bottom:13px;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d3d175a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./packages/SrQiankunView/SrQiankunView.vue
// module id = 249
// module chunks = 0